/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types'
import {
  filterContainerStyle,
  filterPillStyle,
  filterPillActiveStyle,
} from '../styles'

/**
 * HighlightFilterPills component for filtering highlights
 * @param {Object} props - Component props
 * @param {Array} props.categories - Array of filter categories
 * @param {string} props.activeFilter - Currently active filter
 * @param {Function} props.onFilterChange - Filter change handler
 * @returns {JSX.Element} HighlightFilterPills component
 */
const HighlightFilterPills = ({ categories, activeFilter, onFilterChange }) => {
  const handleFilterClick = (category) => {
    if (onFilterChange) {
      onFilterChange(category)
    }
  }

  return (
    <div css={filterContainerStyle}>
      {categories.map((category) => (
        <button
          key={category}
          type='button'
          css={
            activeFilter === category ? filterPillActiveStyle : filterPillStyle
          }
          onClick={() => handleFilterClick(category)}
        >
          {category}
        </button>
      ))}
    </div>
  )
}

HighlightFilterPills.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func,
}

HighlightFilterPills.defaultProps = {
  onFilterChange: null,
}

export default HighlightFilterPills
